import { useAuth } from '@/hooks/auth'
import { useState, useEffect } from 'react'

const AppLayout = ({ header, children }) => {

    const { logout } = useAuth({ middleware: 'auth', role: 'dashboard' })
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div>
            <div className={`pageloader ${isLoading ? "is-active" : ""}`}></div>

            {/* Page Content */}
            <main>{children}</main>
        </div>
    )
}

export default AppLayout
